import CountUp from "react-countup";
import React, { useEffect, useState } from 'react';

export default function AboutCounter() {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    // mark client after hydration — CountUp will only render on client
    setIsClient(true);
  }, []);
  return (
    <>
      <section className="about-counter">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-sm-12 col-md-6 col-lg-6">
              <div className="text-section">
                <div className="wow animate__animated animate__slideInLeft" data-wow-delay="0.1s" data-wow-duration="1.2s" >
                  <span className="gradient-color">Why Choose Supershine</span>
                  <h2 className="heading"> Built for Consistent <br/> Growth</h2>
                  <div className="text">
                    <p>At Supershine, we combine three decades of operational knowledge with standardized systems to deliver commercial laundry solutions businesses trust. Our experience across 5600+ installations ensures your operations achieve predictable quality, reduced downtime, and sustainable performance.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right counter boxes */}
            <div className="col-sm-12 col-md-6 col-lg-6">
              <div className="grid-section">
                <div className="row">

                  <div className="col-6 col-sm-6 col-md-6">
                    <div className="grid-box">
                      <h2 className="heading">
                        <span className="stat-number"> {isClient ? <CountUp start={0} end={4200} duration={7} /> : "4200"}</span>+
                      </h2>
                      <p>Clients Served</p>
                    </div>
                  </div>

                  <div className="col-6 col-sm-6 col-md-6">
                    <div className="grid-box">
                      <h2 className="heading">
                        <span className="stat-number"> {isClient ? <CountUp start={0} end={35} duration={7} /> : "35"}</span>+
                      </h2>
                      <p>Years of Experience</p>
                    </div>
                  </div>

                  <div className="col-6 col-sm-6 col-md-6">
                    <div className="grid-box last-box">
                      <h2 className="heading">
                        <span className="stat-number"> {isClient ? <CountUp start={0} end={5600} duration={7} /> : "5600"}</span>+
                      </h2>
                      <p>Installations done</p>
                    </div>
                  </div>

                  <div className="col-6 col-sm-6 col-md-6">
                    <div className="grid-box last-box">
                      <h2 className="heading">
                        <span className="stat-number"> {isClient ? <CountUp start={0} end={700} duration={7} /> : "700"}</span>+
                      </h2>
                      <p>Team Members</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}




